import { render } from "./Fortune.vue?vue&type=template&id=ee4bb126&scoped=true"
import script from "./Fortune.vue?vue&type=script&lang=js"
export * from "./Fortune.vue?vue&type=script&lang=js"

import "./Fortune.vue?vue&type=style&index=0&id=ee4bb126&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee4bb126"]])

export default __exports__